const smoothScroll = () => {

    let header_height = jQuery("header").height();
    let offset = header_height + 30;

    if (jQuery(window).width() < 768) {
        offset = header_height + 15;
    }

    if (window.location.hash) {

        scroll(0, 0);
        setTimeout(function () { scroll(0, 0); }, 1);

        jQuery('html, body').animate({
            scrollTop: (jQuery(window.location.hash).offset().top - offset)
        }, 1000, 'swing');

    }

    jQuery('a[href*="#"]')
        .not('[href^="/"]')
        .not('[href="#"]')
        .not('[href="#modal_request_quote"]')
        .on('click', function(event) {

                    event.preventDefault();

                        jQuery('html, body').animate({
                scrollTop: jQuery( jQuery.attr(this, 'href') ).offset().top - offset
            }, 500);

    });

};